<template>
    <div
        class="gwb-float-field"
        :class="{ 'gwb-float-field--active': isLabelRaised }"
    >
        <label v-if="type !== 'tel'" :for="id">{{ label }}</label>
        <div class="gwb-float-field__button-container">
            <select
                v-if="type === 'select'"
                :id="id"
                :name="name"
                :value="value"
                @input="$emit('input', $event.target.value)"
                @change="$emit('change', $event.target.value)"
                @focus="
                    ($event) => {
                        inFocus = true;
                        $emit('focus', $event);
                    }
                "
                @blur="
                    ($event) => {
                        inFocus = false;
                        $emit('blur', $event);
                    }
                "
                :class="{ error: error }"
            >
                <slot name="options" />
            </select>
            <div v-else-if="type === 'tel'" class="w-full">
                <label :for="id">{{ telephoneLabel }}</label>
                <div class="flex w-full">
                    <gwb-select
                        ref="areacode"
                        :id="id"
                        filterable
                        v-model="areacode"
                        :placeholder="isLabelRaised ? $lang('m.areacode') : undefined"
                        :error="error"
                        @input="emitNumber"
                        @change="emitNumber"
                        @focus="
                            ($event) => {
                                inFocus = true;
                                $emit('focus', $event);
                            }
                        "
                        @blur="
                            ($event) => {
                                inFocus = false;
                                $emit('blur', $event);
                            }
                        "
                        :class="{ error: error }"
                    >
                        <gwb-option v-for="(area, key) in area_codes" :key="key" :value="area.code" :label="`${area.country} (${area.code})`" />
                    </gwb-select>
                    <input
                        class="w-auto"
                        ref="phonenumber"
                        :type="type"
                        :id="id"
                        :name="name"
                        v-model="number"
                        :autocomplete="autocomplete"
                        @keyup.delete="clearField"
                        @input="emitNumber"
                        @change="emitNumber"
                        @focus="
                            ($event) => {
                                inFocus = true;
                                $emit('focus', $event);
                            }
                        "
                        @blur="
                            ($event) => {
                                inFocus = false;
                                $emit('blur', $event);
                            }
                        "
                        :class="{ error: error }"
                    />
                </div>
            </div>
            <input
                v-else
                :type="type"
                :id="id"
                :name="name"
                :value="value"
                :autocomplete="autocomplete"
                @input="$emit('input', $event.target.value)"
                @change="$emit('change', $event.target.value)"
                @focus="
                    ($event) => {
                        inFocus = true;
                        $emit('focus', $event);
                    }
                "
                @blur="
                    ($event) => {
                        inFocus = false;
                        $emit('blur', $event);
                    }
                "
                :class="{ error: error }"
            />
            <slot name="button" />
        </div>
    </div>
</template>

<script>

export default {
    name: "GwbFloatField",

    props: {
        type: {
            type: String,
            default: "text",
        },

        value: {
            type: [String, Number],
            default: "",
        },

        id: {
            type: String,
            default: "",
        },

        name: {
            type: String,
            default: "",
        },

        label: {
            type: String,
            default: "",
        },

        error: {
            type: Boolean,
            default: false,
        },

        autocomplete: {
            type: String,
            default: undefined,
        },
        filterable: {
            type: Boolean,
            default: false,
        },
        initAreaCode: {
            type: String,
            default: undefined,
        },
    },

    data() {
        return {
            inFocus: false,
            area_codes: window.gwbSrv.area_codes,
            areacode: this.initAreaCode ? this.initAreaCode : undefined,
            number: undefined,
        };
    },

    mounted() {
        if (this.type === 'tel' && this.value) {
            // Initialize number from initial value
            const matchedArea = this.area_codes.find(area => this.value.startsWith(area.code));
            if (matchedArea) {
                this.areacode = matchedArea.code;
                this.number = this.value.substring(matchedArea.code.length);
            } else {
                this.number = this.value;
            }
        }
    },

    watch: {
        areacode() {
            this.emitNumber();
        },
        value(val) {
            if (this.type === 'tel') {
                this.checkForAreaCode(val) && (this.areacode = val);

            }
        },
        number(val) {
            this.area_codes.forEach(element => {
                if (val.includes(element.code)) {
                    this.areacode = element.code;
                    this.number = this.number.replace(element.code, '')
                    this.emitNumber()
                }
            });
        },
    },

    computed: {
        isLabelRaised() {
            return this.inFocus || this.value || (this.value && this.value.length > 0) || this.areacode;
        },
        numberWithAreaCode() {
            if (this.areacode && this.number) {
                return this.areacode + this.number;
            }
            return this.areacode;
        },
        telephoneLabel() {
            return this.label;
        }
    },

    methods: {
        emitNumber() {
            this.$emit('input', this.numberWithAreaCode);
        },
        checkForAreaCode(val) {
            return this.area_codes.some((area) => val === area.code);
        },
        clearField() {
            if (!this.value || this.value.length === 0) {
                this.$refs.areacode.$refs.input.focus()
            }
        }
    },
};
</script>
<style type="scss">
    .c-form-input__input{
        border: none;
    }
    .c-select .c-form-input__input {
        background-color: transparent;
        padding: 0.5rem 0;
    }
    .c-form-input__input:read-only{
        background-color: transparent;
    }
    .c-select .c-form-input__append-icon{
        display: none;
    }
    .c-select__input {
        margin-right: 0.75rem;
    }
</style>
